import { useEffect, useState } from "react";
import { AuthContext } from "./AuthContext";
import { User } from "../../types/User";
import { useAmplifly } from "../../hooks/useAmplify";
import { storage } from "../../utils/storage";

const AuthProvider = ({ children }: { children: JSX.Element }) => {

    const [user, setUser] = useState<User | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const amplify = useAmplifly();

    useEffect(() => {
        console.log("AuthProvider initializing...")
        const validateToken = async () => {
            setIsLoading(true);
            try {
                const result = await amplify.validateToken('');
                if (result.user) {
                    setUser(result.user);
                    console.log('Token validated successfully');
                } else {
                    console.log('No valid token found');
                    setUser(null);
                }
            } catch (error) {
                console.log('Token validation failed:', error);
                localStorage.removeItem('authToken');
                setUser(null);
            } finally {
                // SEMPRE sair do loading, mesmo com erro
                setIsLoading(false);
            }
        }
        validateToken();
    }, []); // Remover amplify da dependência para evitar re-execução

    const signin = async (username: string, password: string) => {
        const { user, token } = await amplify.signin(username, password);

        if (user && token) {
            setUser(user);
            setToken(token);
            return true;
        }
        return false;
    }

    const signout = async () => {
        setUser(null);
        setToken('');
        
        // Limpar todos os dados persistidos
        storage.clearAll();
        
        await amplify.signout();
    }

    const setToken = (token: string) => {
        localStorage.setItem('authToken', token);
    }

    // Show loading while validating token
    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-lg">Validando sessão...</div>
            </div>
        );
    }

    return (
        <AuthContext.Provider value={{ user, signin, signout }}>
            {children}
        </AuthContext.Provider>
    );

};

export default AuthProvider;